/*
  KvD: Listen-Filter mit nur einem waehlbaren Wert eingeklappt anzeigen (Desktop).
  - "Waehlbar" = Checkbox nicht deaktiviert (Anzahl > 0) oder bereits angehakt.
  - Ist der eine Wert angehakt, bleibt der Filter offen.
  - Nach dem Filtern (AJAX) wird nur umgeschaltet, wenn sich der Status aendert
    (1 Wert <-> mehrere Werte). Manuelles Auf-/Zuklappen bleibt sonst erhalten.
  - Preis-Filter und andere Filter ohne Checkboxen werden nicht angefasst.
*/
(() => {
  if (window.kvdFacetCollapseLoaded) return;
  window.kvdFacetCollapseLoaded = true;

  function kvdIsSingle(details) {
    const boxes = details.querySelectorAll('.facets__display input[type="checkbox"]');
    if (!boxes.length) return null;
    let available = 0;
    let checked = 0;
    boxes.forEach((box) => {
      if (box.checked) checked += 1;
      if (!box.disabled || box.checked) available += 1;
    });
    return available <= 1 && checked === 0;
  }

  function kvdCollapseSingleFilters() {
    document.querySelectorAll("#FacetFiltersForm details.js-filter").forEach((details) => {
      const single = kvdIsSingle(details);
      if (single === null) return;
      const now = single ? "1" : "0";
      const prev = details.dataset.kvdSingle;
      if (prev === now) return;
      details.dataset.kvdSingle = now;
      if (prev === undefined) {
        // Erster Durchlauf: nur Ein-Wert-Filter zuklappen, Rest wie vom Theme vorgegeben.
        if (single) details.open = false;
        return;
      }
      details.open = !single;
    });
  }

  let kvdScheduled = false;
  function kvdSchedule() {
    if (kvdScheduled) return;
    kvdScheduled = true;
    requestAnimationFrame(() => {
      kvdScheduled = false;
      kvdCollapseSingleFilters();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", kvdCollapseSingleFilters);
  } else {
    kvdCollapseSingleFilters();
  }
  new MutationObserver(kvdSchedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();